const Footer = () => {
    return (
        <div
            className="text-center p-3"
        >
        © 2026 Saber Astronautics
        </div>
    );
};

export default Footer;
